<template>
	<div style="background: #efefef;">

		<div class="css-my-head">
			<img :src='userInfo.head' @click="gotoPage('/auth/phone')">
			<div>{{userInfo.nickname}}</div>
		</div> 

		<div class="my-btn" style="clear: both;height: 1rem;padding: 1.0rem 0;background: white;">
			<router-link to="/order/list?act=1">
				<i class="iconfont icon-daifukuan"></i><br>
				<span>待付款</span>
			</router-link>
			<router-link to="/order/list?act=2">
				<i class="iconfont icon-daifahuo"></i><br>
				<span>待发货</span>
			</router-link>
			<router-link to="/order/list?act=3">
				<i class="iconfont icon-daishouhuo"></i><br>
				<span>待收货</span>
			</router-link>
			<router-link to="/order/list?act=5">
				<i class="iconfont icon-pingjia"></i><br>
				<span>待评价</span>
			</router-link>
			<router-link to="/order/list?act=7">
				<i class="iconfont icon-tuikuan"></i><br>
				<span>售后</span>
			</router-link>
		</div>

		<ul class="my-list" style="background: #ffffff; font-size: .8rem;">
			<li @click="gotoPage('/cart')">
				<i class="iconfont icon-gouwuche"></i>
				<span> 购物车</span>
			</li>
			<!-- <li @click="gotoPage('/cart')">
				<i class="iconfont icon-shoucang"></i>
				<span> 我的收藏</span>
			</li> -->
			<li @click="gotoPage('/user/address')">
				<i class="iconfont icon-dizhi"></i>
				<span> 收货地址</span>
			</li>
			<li @click="gotoPage('/cart')">
				<i class="iconfont icon-kefu"></i>
				<span> 帮助与客服</span>
			</li>
			<!-- <li @click="gotoPage('/cart')">
				<i class="iconfont icon-shezhi"></i>
				<span> 账号与安全</span>
			</li> -->
			
			<span style="display: block;margin: 1rem auto; text-align: center;color: #bababa;font-size: 0.5rem;">v2026.03.28</span>
			<!-- <div class="beian" >
			<span style="color: black;">版权所有 Copyright  君庭（广州）商务服务有限公司</span>
			<a href="https://beian.miit.gov.cn/">粤ICP备2025488554号-1</a>
			<span style="color: black;">All Rights Reserved.</span>
			</div> -->
		</ul>

		<!-- 组件声明 -->
		<foot />
		<syalert ref="syalert_id" />

	</div>
</template>

<style>
	.beian
	{
		/* font-size: .5rem; */
	}
	.my-btn a
	{
		text-decoration: none;
		width: 20%;
		text-align: center;
		background: #ffffff;
		font-size: .8rem;
		float: left;
		color: #aaa;
	}
	.my-btn i
	{
		/* color: #efefef; */
		color: #aaa;
	}
	.my-btn span
	{
		margin: .5rem 0;
	}

	.css-my-head {
		height: 10rem;
		text-align: center;
		/* background-color: #ff9a9a; */
		background-color: rgba(255, 96, 96, 0.9);
		/* background-image:url('www.symeet.xyz/demo.jpg'); */
		/* opacity:0.60; */
		border-top-left-radius: 0.5rem;
		border-top-right-radius: 0.5rem;
	}

	.css-my-head img {
		border-radius: 2rem;
		width: 4rem;
		height: 4rem;
		margin: 2rem auto 1rem auto;
	}

	.css-my-head div {
		line-height: 2rem;
		font-size: .9rem;
		color: #fff;
	}

	.css-my-head div i {
		margin: .5rem;
		font-size: 1.2rem;
	}
 
</style>
<script>
	// 组件引入
	import sy from "@/sy";

	import foot from "@/components/foot.vue"
	import syalert from '@/components/syalert.vue';
	import logo from "@/assets/image/logo.jpg";

	export default {
		name: 'user',
		// 组件注册
		components: {
			foot,
			syalert,
		},
		data() {
			return {
				userInfo: {
					head: logo,
					nickname: '暂未登录',
				},
			}
		},
		methods: {
			gotoPage: function(page) {
				if (page !== undefined) {
					this.$router.push(page);
				} else {
					this.$router.go(-1);
				}
			},
			// 订单列表
			toOrderList(act) {
				this.$router.push('/order/list?act=' + act);
			},
			syalert_tip: function(msg) {
				// 组件调用
				this.$refs.syalert_id.syalert(msg);
			},


			check: function() {
				// 重命名实例
				let $_this = this;
				sy.http.get({
					url: this.$root.API + 'User/My',
					success: function(res) {
						//$_this.userInfo = res.data;
						$_this.userInfo.nickname = res.data.nickname;
						// 如果有提示会一直给他提示 知道处理完
					}
				});
			},


		},
		created() {
			this.check();
		}
	}
</script>